module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-05-e99d4eebf8999c8e8d6cde2ae3dda09f.jpg";